import * as actions from './actions';

export type State = {
  loading: boolean;
  videoData: Record<string, any>;
  financialWellnessTiles: Array<Record<string, any>>;
  tilesInformation: Record<string, any>;
  navigationOptions: Array<Record<string, any>>;
  distroTilesInformation:  Record<string, any>;
  error: object;
};

export default (
  state: State = {
    loading: false,
    videoData: {},
    financialWellnessTiles: [],
    tilesInformation: [],
    navigationOptions: [],
    distroTilesInformation: [],
    error: {},
  },
  action: any,
): State => {
  switch (action.type) {
    case actions.FETCH_VIDEO_URL:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_VIDEO_URL_SUCCESS:
      return {
        ...state,
        videoData: action.payload,
      };
    case actions.FETCH_VIDEO_URL_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case actions.FETCH_FINANCIAL_WELLNESS_TILES:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_FINANCIAL_WELLNESS_TILES_SUCCESS:
      return {
        ...state,
        financialWellnessTiles: action.payload,
        loading: false,
      };
    case actions.FETCH_FINANCIAL_WELLNESS_TILES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.FETCH_NAVIGATION_OPTIONS:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_NAVIGATION_OPTIONS_SUCCESS:
      return {
        ...state,
        navigationOptions: action.payload,
        loading: false,
      };
    case actions.FETCH_NAVIGATION_OPTIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.FETCH_TILES_INFORMATION:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_TILES_INFORMATION_SUCCESS:
      return {
        ...state,
        tilesInformation: action.payload,
        loading: false,
      };
    case actions.FETCH_TILES_INFORMATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case actions.FETCH_DISTRO_TILES_INFORMATION:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_DISTRO_TILES_INFORMATION_SUCCESS:
      return {
        ...state,
        distroTilesInformation: action.payload,
        loading: false,
      };
    case actions.FETCH_DISTRO_TILES_INFORMATION_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
